import { render } from "./partsList.vue?vue&type=template&id=c34a96c4&scoped=true"
import script from "./partsList.vue?vue&type=script&lang=js"
export * from "./partsList.vue?vue&type=script&lang=js"

import "./partsList.vue?vue&type=style&index=0&id=c34a96c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c34a96c4"]])

export default __exports__